import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';

const NavigationContainer = styled.div`
    display:flex;
    flex-direction:row;
    width:6rem;
    justify-content: space-between;
`;
const ActiveNavigation = styled.img`
    display: flex;
    flex-direction: row;
    padding: var(--space-14);
    cursor:pointer;
    width: 2.75rem;
    height: 2.75rem;
    padding-bottom: 1rem;
    position: relative;
    bottom: 1rem;
    background-color: var(--color-white);

    border: 1px solid #EDF0F2;
    box-sizing: border-box;

    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 62.5rem;
    
    
`;

const DisabledNavigation = styled.img`
    position: relative;
    bottom: 1rem;
    display: flex;
    flex-direction: row;
    padding: var(--space-14);

    width: 2.75rem;
    height: 2.75rem;

    background-color: var(--color-gray-200);

    border: 1px solid #EDF0F2;
    box-sizing: border-box;

    border-radius: 62.5rem;
    
`;

const CycleButtonComponent = () => {
    return (
        <p>Test</p>
    )
}

export default CycleButtonComponent

export const ActiveButton = () => {
    return (
        <ActiveNavigation src="/client-reviews/active_chevron.svg"/>
    )
}
export const DisabledButton = () => {
    return (
        <DisabledNavigation src="/client-reviews/disabled_chevron.svg"/>
    )
}
